import { createSlice } from '@reduxjs/toolkit';
import { createReducerNames } from '../../../core/helpers/default';

const name = 'editCustomMethod';

const reducersKeys = {
  editRequest: 'editRequest',
  editSuccess: 'editSuccess',
  editFailure: 'editFailure',
};

const initialState = {
  edited: false,
  loading: false,
  error: null,
};

const slice = createSlice({
  name,
  initialState,
  reducers: {
    [reducersKeys.editRequest]: (state) => {
      state.loading = true;
      state.edited = false;
    },
    [reducersKeys.editSuccess]: (state) => {
      state.loading = false;
      state.edited = true;
    },
    [reducersKeys.editFailure]: (state, { payload }) => {
      state.loading = false;
      state.error = payload.error;
    },
  },
});

export const editCustomMethodReducer = createReducerNames(name, reducersKeys);
export const { actions } = slice;

export default slice.reducer;
